import { render, staticRenderFns } from "./JadwalKonsultasi.vue?vue&type=template&id=76d7fa5a"
import script from "./JadwalKonsultasi.vue?vue&type=script&lang=js"
export * from "./JadwalKonsultasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports